import * as yup from "yup";

export const confirmationSchema = yup.object({
    email: yup
        .string()
        .email("* nieprawidłowy adres e-mail")
        .required("* pole wymagane"),
    code: yup.string().min(6, " ").required(),
});
